/** Период покачивания static.png, сек. Слегка разный у соседних, чтобы не синхронизировались. */
const SVAMI_STATIC_WOBBLE_DURATIONS_SEC = [2.2, 2.4, 2.6, 2.8] as const;

export function svamiStaticWobbleDurationSec(index: number): number {
  return SVAMI_STATIC_WOBBLE_DURATIONS_SEC[index % SVAMI_STATIC_WOBBLE_DURATIONS_SEC.length];
}
